import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel'
import ModalConfirm from '@/components/modals/modal-confirm.vue'
import SubmitButton from '@/components/buttons/submit-button.vue'
import Callout from '@/components/notifications/callout.vue'
import DashboardToggleBar from '@/components/analytics/details/dashboard-toggle-bar.vue'
import CookieConsentButton from '@/components/buttons/cookie-consent-button.vue'
import Comments from '@/components/comments/comments.vue'
import HomeCarousel from '@/components/carousels/home-carousel.vue'
import AboutCarousel from '@/components/carousels/about-carousel.vue'
import PlanCard from '@/components/plans/plan-card.vue'

/**
 * Components loaded in app.js and not code split
 */
export function commonComponentsInit() {
  /* CARDS */
  // only plan card used on homepage current for all users
  Vue.component('plan-card', PlanCard)

  // ctas and callouts
  Vue.component('modal-confirm', ModalConfirm)
  Vue.component('submit-button', SubmitButton)
  Vue.component('callout', Callout)
  Vue.component('dashboard-toggle-bar', DashboardToggleBar)
  Vue.component('cookie-consent-button', CookieConsentButton)

  // home, about
  Vue.component('home-carousel', HomeCarousel)
  Vue.component('about-carousel', AboutCarousel)

  // comments widget
  Vue.component('comments', Comments)

  // only used on my dashboard
  Vue.component('carousel', Carousel)
  Vue.component('slide', Slide)
}
